import React, {
  ComponentType,
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState
} from 'react'
import { CSSTransition, TransitionGroup } from 'react-transition-group'
import { getMergedClassNames, getUniqueKey } from '../../utils/HTMLutils'
import { ModalProps } from '../modal/Modal'
import { ModalMask } from '../modal/ModalMask'
import './../modal/Modal.scss'
import './ModalManager.scss'

const rootClassName = 'comp-modal-manager'
const maskRootClassName = 'component-modal-mask'

const hackFocus = () => {
  const tmp = document.createElement('input')
  document.body.appendChild(tmp)
  tmp.focus()
  document.body.removeChild(tmp)
}

export const ModalManager = forwardRef((_props, ref) => {
  const [arrayOfModal, setArrayOfModal] = useState<
    { props?: ModalProps; component?: React.ReactNode }[]
  >([])
  const refModals = useRef(arrayOfModal)
  refModals.current = arrayOfModal

  useEffect(() => {
    const escapeCall = (evt: any) => {
      if (evt.key === 'Escape' && refModals.current.length) {
        const mprops = refModals.current[refModals.current.length - 1].props
        if (!mprops?.preventEscExit) {
          closeModalByKey(mprops?.modalKey)
          if (typeof mprops?.onClose === 'function') {
            mprops?.onClose(mprops?.modalKey)
          }
        }
      }
    }
    document.addEventListener('keydown', escapeCall)
    return () => {
      document.removeEventListener('keydown', escapeCall)
    }
  }, [])

  const closeModalByKey = (modalKey?: string | number) => {
    let arr = refModals.current.slice()
    arr = arr.filter(
      (obj: any) => String(obj.props.modalKey) !== String(modalKey)
    )
    setArrayOfModal(arr)
  }

  useImperativeHandle(ref, () => ({
    openModal<C extends React.ElementType, P extends React.ComponentProps<C>>(
      component: C,
      modalProps: P
    ) {
      const modalKey = modalProps.modalKey
        ? modalProps.modalKey
        : getUniqueKey()
      if (typeof component === 'function') {
        const arr = refModals.current.slice()
        const p = {
          ...modalProps,
          modalKey,
          onClose: (modalKey?: string | number) => {
            closeModalByKey(modalKey)
            if (typeof modalProps.onClose === 'function') {
              modalProps.onClose(modalKey)
            }
          }
        }
        arr.push({ component, props: p })
        setArrayOfModal(arr)
        hackFocus()

        return modalKey
      }
      return ''
    },
    closeModal(modalKey: string | number) {
      if (modalKey) {
        closeModalByKey(modalKey)
      } else if (refModals.current.length) {
        closeModalByKey(
          refModals.current[refModals.current.length - 1]?.props?.modalKey
        )
      }
    }
  }))

  const getClassNames = () => {
    return getMergedClassNames([`${rootClassName}-modals`])
  }

  return (
    <React.Fragment>
      <TransitionGroup className={getClassNames()}>
        {arrayOfModal.map((obj) => {
          const M = obj.component as ComponentType
          return (
            <CSSTransition
              timeout={300}
              classNames={
                obj.props?.mobileOnXS
                  ? `${rootClassName}-mask-mobile-on-xs`
                  : `${rootClassName}-mask`
              }
              key={obj.props?.modalKey}
              unmountOnExit
            >
              <ModalMask
                mobileOnXS={Boolean(obj.props?.mobileOnXS)}
                onClick={(evt: any) => {
                  if (evt.target.classList.contains(maskRootClassName)) {
                    // closeModalByKey(obj.props.modalKey)
                    if (
                      typeof obj.props?.onClose === 'function' &&
                      !obj.props?.preventMaskExit
                    ) {
                      obj.props?.onClose(obj.props?.modalKey)
                    }
                  }
                }}
              >
                <M {...obj.props} />
              </ModalMask>
            </CSSTransition>
          )
        })}
      </TransitionGroup>
    </React.Fragment>
  )
})
